import axios from "axios"
import requesturl from "../requesturl"
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {
    async getPoolGroupAssignmentsForPoolGroup(poolGroupId, poolGroupAssignments) {
        const response = await axios.get(requesturl() + "/api/latest/PoolGroupAssignment/PoolGroup/" + poolGroupId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });

        cookiemanager.updateCookies(response.headers);

        if (response.status === 204) {
            poolGroupAssignments(null);
        } else {
            poolGroupAssignments(response.data);
        }
    },

    async postPoolGroupAssignment(poolGroupAssignment, response) {
        const headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': "application/json"
        };

        await axios({
            method: "post",
            url: requesturl() + "/api/latest/PoolGroupAssignment",
            headers: headers,
            data: JSON.stringify(poolGroupAssignment)
        }).then(res => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }
            response(responseObj);
        });
    },

    async deletePoolGroupAssignment(poolGroupAssignment, response) {
        await axios.delete(requesturl() + "/api/latest/PoolGroupAssignment/" + poolGroupAssignment.poolGroupAssignmentId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                cookiemanager.updateCookies(res.headers);
                let responseObj = {
                    error: false,
                    status: res.status
                };

                response(responseObj);
            })
            .catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };

                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }

                response(responseObj);
            });
    }
}


// WEBPACK FOOTER //
// ./src/interfaces/poolgroupassignmentinterface.js